import { formValidateAndSend, getFormFields } from '../../../js/forms.js';

document.addEventListener(
	'DOMContentLoaded',
	function () {
        var currentPage = 1;
		var buttonSeeMore = document.querySelector('.present-list__see-more');

		function loadPresentes(page) {
			var xhr = new XMLHttpRequest();
			xhr.open('POST', ajax_url, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.onreadystatechange = function() {
				if (xhr.readyState === 4 && xhr.status === 200) {
					var response = JSON.parse(xhr.responseText);
					document.querySelector('.present-list ul').innerHTML += response.data.posts;
					let hasMorePages = response.data.hasMorePages;
					// Ocultar o botão se não houver mais páginas
					if (!hasMorePages) {
						buttonSeeMore.style.display = 'none';
					}
	
				}
			};

			var data = 'action=carregar_lista&page=' + page + '&type=' + variant + '&perPage=' + perPage + '&textBuy=' + textBuy + '&textSold=' + textSold;
			xhr.send(data);
		}		

		// Lidar com o clique no botão "Ver Mais"
		if(buttonSeeMore){
			buttonSeeMore.addEventListener('click', function() {
				currentPage++;
				loadPresentes(currentPage);
			});
		}


		var buyModal = document.querySelector('.modal-pagamento');
		if(buyModal){

			var modalOverlay = document.querySelector('.modal-pagamento__overlay');
			
			var modaClose = document.querySelector('.modal-pagamento__close');
	
			if(modalOverlay)
				modalOverlay.addEventListener('click', () =>{
					closeModal();
				})
	
			if(modaClose)
				modaClose.addEventListener('click', () =>{
					closeModal();
				})
	
			function closeModal(){
				buyModal.classList.remove('open');
				modalOverlay.classList.remove('open');
			}
	
			var inputValue = document.querySelector('.modal-pagamento__form [name="valor_pago"]')
			if(inputValue){
				inputValue.addEventListener('input', function(event) {
					var input = event.target;
					var valor = input.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
					var valorFormatado = 'R$ ' + formatarNumero(valor);
				
					input.value = valorFormatado;
				});
			}
	
	
			var buyButton = document.querySelector('.modal-pagamento .submit__form__button');
			var buyForms = document.querySelector('.modal-pagamento__form');
			const errorMessage = buyForms.getAttribute('data-msg');
			const errorElement = document.querySelector('.modal-pagamento .return_message.error_message');
			const successElement =  document.querySelector('.modal-pagamento .return_message.success_message');
	
			const buyFormsInputs = getFormFields('.modal-pagamento__form', 'input');
			if(buyButton){
				buyButton.addEventListener('click', (e) => {
					e.preventDefault();
					if(inputValue)
						inputValue.value = inputValue.value.replace("R$ ", "")
					formValidateAndSend(buyForms, errorMessage, successElement, errorElement, "presente", buyButton, buyFormsInputs) 
					if(inputValue)
						inputValue.value = "R$ " + inputValue.value
					
				})
			}
	
			
			
			function formatarNumero(numero) {
				// Adiciona zeros à esquerda se necessário para ter pelo menos 2 dígitos
				while (numero.length < 3) {
					numero = '0' + numero;
				}
			
				// Divide a parte inteira e a parte decimal
				var parteInteira = numero.slice(0, -2) || '';
				var parteDecimal = numero.slice(-2);
			
				// Remove zeros à esquerda apenas se for um número inteiro
				parteInteira = parteInteira.replace(/^0+(?=\d+$)/, '');
	
				return parteInteira + ',' + parteDecimal;
			}
		}
		

	},
	false
);
